import { getSimilarProducts } from './getSimilarProducts'

export * as Crosses from './types'

export const crosses = {
  getSimilarProducts
}
